import { DocsLinksSection } from 'components/docs/docs-links-section';

const DocsGuidesSection = ({ section }) => <DocsLinksSection icon='graduation-cap' section={section} />;

export { DocsGuidesSection };
